(ns hai.ui.components.new-design.typography
  {:ornament/prefix ""}
  #?(:cljs (:require-macros hai.ui.components.new-design.typography))
  (:require
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]
   [hai.ui.components.new-design.utils :refer [px->rem]]))

(o/defstyled heading :_mixin
  {:color t/--text-primary})

;; TODO remove `text` and remove *
(o/defstyled text* :_mixin
  {:font-family t/--font-family
   :font-size "16px"
   :line-height "1.6rem"
   :font-weight "500"
   :color t/--text-secondary})

(o/defstyled h1 :h1
  heading
  {:font-size (px->rem 48)
   :font-weight "800"
   :line-height (px->rem 48)
   :letter-spacing "-0.02rem"}
  ;; 3rem is oversized on narrow viewports; drop to 2rem on mobile.
  [:at-media {:max-width "768px"}
   {:font-size (px->rem 32)
    :line-height (px->rem 32)}])

(o/defstyled h2 :h2
  heading
  {:font-size (px->rem 32)
   :font-weight "700"
   :line-height "1.3rem"
   :letter-spacing "-0.01rem"})

(o/defstyled h3 :h3
  heading
  {:font-size (px->rem 24)
   :font-weight "700"
   :line-height "1.4rem"})

(o/defstyled h4 :h4
  heading
  {:font-size (px->rem 18)
   :font-weight "600"
   :line-height "1.5rem"})

(o/defrules typography
  [[:html text*]
   [:strong {:font-weight "600"}]
   [:h1 h1]
   [:h2 h2]
   [:h3 h3]
   [:h4 h4]])

(o/defstyled text :span)

;;; Overriding Radix Theme's defaults

;; This is defined by Radix Themes and we use it below to override Radix Theme's font
(o/defprop --default-font-family)

(o/defrules radix-themes-integration
  [[":where(html)" text*]
   [:.radix-themes {--default-font-family t/--font-family
                    :color t/--text-secondary}]])
